<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<h2 class="CH1_Chapter_title_1 ParaOverride-2" id="_idParaDest-2"><span class="Italic CharOverride-2">Also by Christopher Brookmyre</span></h2>
<p class="ABL_Also_by_list_item">Quite Ugly One Morning</p>
<p class="ABL_Also_by_list_item">Country of the Blind</p>
<p class="ABL_Also_by_list_item">Not the End of the World</p>
<p class="ABL_Also_by_list_item">One Fine Day in the Middle of the Night</p>
<p class="ABL_Also_by_list_item">Boiling a Frog</p>
<p class="ABL_Also_by_list_item">A Big Boy Did It and Ran Away</p>
<p class="ABL_Also_by_list_item">The Sacred Art of Stealing</p>
<p class="ABL_Also_by_list_item">Be My Enemy</p>
<p class="ABL_Also_by_list_item">All Fun and Games until Somebody Loses an Eye</p>
<p class="ABL_Also_by_list_item">A Tale Etched in Blood and Hard Black Pencil</p>
<p class="ABL_Also_by_list_item">Attack of the Unsinkable Rubber Ducks</p>
<p class="ABL_Also_by_list_item">A Snowball in Hell</p>
<p class="ABL_Also_by_list_item">Pandaemonium</p>
<p class="ABL_Also_by_list_item">Where the Bodies are Buried</p>
<p class="ABL_Also_by_list_item">When the Devil Drives</p>
<p class="ABL_Also_by_list_item">Bedlam</p>
<p class="ABL_Also_by_list_item">Bred in the Bone</p>
<p class="ABL_Also_by_list_item">Dead Girl Walking</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// RR0208-1.vue?ac85f5aa